import { Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AddButton = styled(Grid)({
  position: "fixed",
  marginLeft: "220px",
  marginTop: "15px",
});

export const AddButtonCv = styled(Grid)({
  position: "fixed",
  marginLeft: "240px",
  marginTop: "17px",
});

export const StatusCvContainer = styled(Grid)({
  height: "60px",
  width: "250px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",

  "&:hover": {
    overflow: "auto",
  },
});

export const Container = styled(Grid)({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  maxWidth: "250px",

  "&:hover": {
    cursor: "pointer",
    overflow: "auto",
  },
});

export const SkillsBlock = styled(Grid)({
  height: "60px",
  width: "220px",
  display: "flex",
  flexDirection: "row",
});

export const SkillsContainer = styled(Grid)({
  width: "210px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: "2",
  WebkitBoxOrient: "vertical",
  whiteSpace: "break-spaces",
  height: "40px",
  cursor: "pointer",
});

export const Skills = styled(Typography)({
  "&:hover": {
    cursor: "pointer",
  },
});
